import { ListingType } from 'algolia-api/types/ListingType';
import { StaffTypeFilter } from 'algolia-api/types/StaffTypeFilter';
import { Select } from 'components/Select/Select';
import { LISTING_TYPE_HUMAN_NAME_MAP_SEARCH } from 'utils/constants/general/listingTypeHumanNameMapSearch';

type DisplayedType = ListingType | StaffTypeFilter;

type Props = {
  value: string;
  onChange: (option: ListingType) => void;
  listingTypes: Array<DisplayedType>;
};

export function ListingTypeSelect({
  value,
  onChange,
  listingTypes,
  ...props
}: Props) {
  const options = listingTypes.map((type) => ({
    value: type,
    label: LISTING_TYPE_HUMAN_NAME_MAP_SEARCH[type],
  }));

  return (
    <Select
      isSearchable
      data-qa-id="listing-type-select"
      aria-label={getText('Select listing type')}
      name="listing-type"
      options={options}
      onChange={(newValue) => onChange(newValue?.value as ListingType)}
      value={value}
      isClearable={false}
      disabled={listingTypes.length === 1}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
}
